import { render, staticRenderFns } from "./DraftIndex.vue?vue&type=template&id=d44f418c"
import script from "./DraftIndex.vue?vue&type=script&lang=js"
export * from "./DraftIndex.vue?vue&type=script&lang=js"
import style0 from "./DraftIndex.vue?vue&type=style&index=0&id=d44f418c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports